import {
  StyleSheet,
  ImageBackground,
  SafeAreaView,
  useWindowDimensions,
  Image,
  TouchableOpacity,
  Platform,
} from "react-native";
import React, { useEffect, useMemo, useState } from "react";
import {
  View,
  Text,
  ScrollView,
  Heading,
  Pressable,
  Box,
  ChevronDownIcon,
  ChevronUpIcon,
  HStack,
  PresenceTransition,
} from "native-base";
import { StackScreenProps } from "../../types";
import Accordion from "react-native-collapsible/Accordion";
import Header from "../../components/Header";
import CountUp from "react-countup";
import AsyncStorage from "@react-native-async-storage/async-storage";

const Digital = ({ navigation }: StackScreenProps<"Digital">) => {
  const { width, height } = useWindowDimensions();
  const [currScreen, setCurrScreen] = useState<"home" | "udongo" | "agroplus">(
    "home"
  );
  const [activeSections, setActiveSections] = useState<number[]>([0]);

  type Section = {
    title: string;
    content: string[];
    index: number;
  };
  const SECTIONS = [
    {
      title: "Key Features",
      content: [
        "- Agronomy content",
        "- Fertilizer Recommendation",
        "- Wheather Services",
        "- Product Catalogue",
        "- Farmer Database",
        "- Product Management",
        "- Stock Managment",
      ],
      index: 0,
    },
    // {
    //   title: "Key Figures",
    //   content: [
    //     "- 200K+ Farmers",
    //     "- 500+ Extension Agents",
    //     "- 350+ Agrodealers",
    //   ],
    //   index: 1,
    // },
  ];

  const SECTIONS2 = [
    {
      title: "Objectives",
      content: [
        "• Regional Nutrient Maps",
        "• Crops Nutrient Needs",
        "• Recommendations and Reports",
        "• Automatization",
        "• Adapted Formulas",
      ],
      index: 0,
    },
  ];

  const renderHeader = (section: Section) => {
    return (
      <View style={styles.header}>
        <HStack
          justifyContent={"space-between"}
          alignContent="center"
          alignItems={"center"}
        >
          <Text color="#000" fontWeight={"bold"} pl={4}>
            {section.title}
          </Text>
          {activeSections.indexOf(section.index) != -1 ? (
            <ChevronUpIcon style={{ marginRight: 5 }} />
          ) : (
            <ChevronDownIcon style={{ marginRight: 5 }} />
          )}
        </HStack>
      </View>
    );
  };

  const renderContent = (section: Section) => {
    return (
      <View style={styles.content}>
        {section.content.map((item) => (
          <Text key={item} color="#000" fontWeight={"bold"}>
            {item}
          </Text>
        ))}
      </View>
    );
  };

  const updateSections = (activeSections: number[]) => {
    // console.log({ activeSections });
    setActiveSections(activeSections);
  };

  const BackButton = () => (
    <Pressable onPress={() => setCurrScreen("home")}>
      <Image
        source={require("../../assets/vectors/chevron-left.png")}
        style={{ width: 15, height: 15 }}
      />
    </Pressable>
  );

  const getSreenColor = useMemo(
    () =>
      currScreen === "home"
        ? "red"
        : currScreen === "udongo"
        ? "#62AF24"
        : "#FF9E18",
    [currScreen]
  );

  const agroPlusDescription =
    "AGRO+ is a platform integrated in Udongo to provide fertilizer recommendation, provide soil nutrient management and enhance good agronomy practises. With AGRO+, OCP Africa possesses an efficient tool that provides farmers with the fertilizer recommendations tailor-made to their region and crop. The tool serves to replace the existing recommendations tools used by many farmers and significantly increases the quality of recommendations and the number of beneficiary farmers. In partnership with UM6P and the Nigeria Institute of Soil Science (NISS), AGRO+ platform will leverage of soil data collected through OCP’s School Lab and other business development initiatives.";
  const udongoDescription =
    "Udongo is an application born out of necessity to unlock digital opportunities in the agricultural sector and spur collaboration between actors in the value chain. Launched in 2019, the digital solution offers farmers the opportunity to access the agricultural input market and local support through the Agri Extension Agents Network. Udongo offers educational and practical content on best agricultural practices and specific advice and recommendations for the farmer. The platform serves as a leverage to enhance business development initiatives in OCP Nigeria projects (Agribooster, School Lab, Farm and Fortune Hubs, etc) to increase the productivity of farmers and collaborations in the Agric value chain. The Udongo App is available on the web and mobile.";

  const [data, setData] = useState({});
  useEffect(() => {
    async function getData() {
      const items = await AsyncStorage.getItem("keyFigures");

      if (items) {
        try {
          setData(JSON.parse(items));
          // console.log(JSON.parse(items));
        } catch (error) {
          console.log(error);
        }
      }
    }

    getData();
  }, []);

  return (
    <ImageBackground
      source={require("../../assets/digital-2.jpg")}
      // resizeMode="contain"
      // resizeMode="contain"
      style={{
        width,
        height,
      }}
    >
      <SafeAreaView style={{ height: "100%" }}>
        <ScrollView style={{ position: "relative", height: "100%" }}>
          <Header
            onPress={() => navigation.navigate("FarmerCentricProjects")}
            parentText="Farmer-Centric Projects"
            headingText="Digital"
            intro=""
          />

          <View>
            <View
              style={{
                // height: 620,
                width: 195,
                backgroundColor: getSreenColor,
                // margin: "auto",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: 80,
                borderRadius: 20,
                height: 400,
                overflow: "hidden",
              }}
            >
              {currScreen == "home" && (
                <>
                  {/* <Heading px={10} pt={10}>
                    DIGITAL
                  </Heading>
                  <Heading px={10}>PLATFORMS</Heading> */}

                  <Pressable
                    onPress={() => {
                      setCurrScreen("udongo");
                    }}
                    bg="#62AF24"
                    // mt={5}
                    flex={1}
                    borderBottomRadius={20}
                    borderTopLeftRadius={20}
                    style={{
                      paddingLeft: 20,
                      paddingTop: 30,
                    }}
                  >
                    <Box
                      bg="#62AF24"
                      flex={1}
                      borderBottomRadius={20}
                      borderTopLeftRadius={50}
                    >
                      <Image
                        source={require("../../assets/udongo_logo.png")}
                        style={{
                          width: 50,
                          height: 50,
                          marginBottom: 10,
                          marginLeft: 20,
                        }}
                      />

                      <Heading size="md" ml={5} mb={5}>
                        UDONGO
                      </Heading>

                      <Pressable
                        onPress={() => {
                          setCurrScreen("agroplus");
                        }}
                        w={"100%"}
                        bg="#FF9E18"
                        flex={1}
                        borderBottomRightRadius={20}
                        borderTopLeftRadius={50}
                      >
                        <Box
                          w={"100%"}
                          bg="#FF9E18"
                          flex={1}
                          borderBottomRightRadius={20}
                          borderTopLeftRadius={50}
                          style={{
                            paddingLeft: 20,
                            paddingTop: 30,
                          }}
                        >
                          <Image
                            source={require("../../assets/udongo_logo.png")}
                            style={{ width: 50, height: 50, marginBottom: 10 }}
                          />
                          <Heading size="md" mb={5}>
                            AGRO+
                          </Heading>
                        </Box>
                      </Pressable>
                    </Box>
                  </Pressable>
                </>
              )}

              {currScreen != "home" && (
                <Box p={5} pt={10} px={1} h={"100%"} overflowY={"scroll"}>
                  <BackButton />
                  {/* <Text
                    textAlign="center"
                    fontSize="xs"
                    textTransform="uppercase"
                    mt={5}
                  >
                    Digital Platforms
                  </Text> */}

                  <Heading size="sm" my={4} textAlign="center">
                    {currScreen == "udongo" ? "UDONGO" : "AGRO+"}
                  </Heading>

                  <Text style={{ fontSize: 14, lineHeight: 22 }} mb={5}>
                    {currScreen == "udongo"
                      ? udongoDescription
                      : agroPlusDescription}
                  </Text>

                  <Accordion
                    sections={currScreen == "udongo" ? SECTIONS : SECTIONS2}
                    activeSections={activeSections}
                    renderHeader={renderHeader}
                    renderContent={renderContent}
                    expandMultiple={true}
                    onChange={updateSections}
                    touchableComponent={TouchableOpacity}
                    sectionContainerStyle={{
                      backgroundColor:
                        currScreen == "udongo" ? "#9ed76f" : "lightorange",
                      borderRadius: 20,
                      marginBottom: 10,
                      borderWidth: 1,
                      borderColor: "#ffffff",
                    }}
                  />

                  {currScreen === "udongo" ? (
                    <>
                      <View>
                        <Text
                          textAlign="center"
                          fontWeight="bold"
                          mb={3}
                          mt={3}
                          fontFamily="Rajdhani-Bold"
                        >
                          Key Figures
                        </Text>

                        <Box
                          // width={"5/6"}
                          // h="16"
                          mb={2}
                          margin="auto"
                          // borderBottomColor="#000"
                          borderColor={"#555"}
                          borderWidth="1"
                          borderRadius={15}
                          p={1}
                          py={2}
                          // pb={2}
                        >
                          <HStack justifyContent={"space-between"}>
                            <View w={"30%"}>
                              <Text
                                fontWeight={"extrabold"}
                                // fontSize="2xl"
                                fontFamily="Rajdhani-Bold"
                                textAlign={"center"}
                              >
                                <CountUp
                                  delay={0}
                                  end={data["digital_1"] / 1000}
                                  suffix="k+"
                                />
                              </Text>
                              <Text
                                fontWeight={"bold"}
                                fontFamily="Rajdhani-Bold"
                                textAlign={"center"}
                              >
                                Farmers
                              </Text>
                            </View>

                            <View w={"30%"}>
                              <Text
                                fontWeight={"extrabold"}
                                // fontSize="2xl"
                                fontFamily="Rajdhani-Bold"
                                textAlign={"center"}
                              >
                                <CountUp delay={0} end={data["digital_2"]} />
                              </Text>
                              <Text
                                fontWeight={"bold"}
                                fontFamily="Rajdhani-Bold"
                                textAlign={"center"}
                              >
                                Extension Farmers
                              </Text>
                            </View>
                            <View w={"30%"}>
                              <Text
                                fontWeight={"extrabold"}
                                // fontSize="2xl"
                                fontFamily="Rajdhani-Bold"
                                textAlign={"center"}
                              >
                                <CountUp
                                  delay={0}
                                  end={data["digital_3"] / 1000}
                                  suffix="+"
                                />
                              </Text>
                              <Text
                                fontWeight={"bold"}
                                fontFamily="Rajdhani-Bold"
                                textAlign={"center"}
                              >
                                Agrodealers
                              </Text>
                            </View>
                          </HStack>
                        </Box>
                      </View>
                    </>
                  ) : (
                    <></>
                  )}
                </Box>
              )}
            </View>
            <Image
              source={require("../../assets/digital.jpg")}
              resizeMode="center"
              style={{
                width: "100%",
                height: 600,
                position: "absolute",
                zIndex: -1,
                margin: "auto",
              }}
            />
          </View>
        </ScrollView>
      </SafeAreaView>
    </ImageBackground>
  );
};

export default Digital;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 127, 109, 0.7)",
  },

  title: {
    textAlign: "center",
    fontSize: 22,
    fontWeight: "300",
    marginBottom: 20,
  },
  header: {
    backgroundColor: "#F5FCFF",
    padding: 10,
    borderRadius: 20,
    // marginBottom: 20,
  },
  headerText: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "500",
  },
  content: {
    padding: 20,
    backgroundColor: "transparent",
    borderRadius: 20,
  },
  active: {
    backgroundColor: "rgba(255,255,255,1)",
  },
  inactive: {
    backgroundColor: "rgba(245,252,255,1)",
  },
});
